import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'LocationDisplay',
})(({ breakpoints, brandColors, type, zLevels, typography }) => ({
  location: {
    ...type['14_medium'],
    color: brandColors.mediumBlue,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(0)}`,

    '&:hover': {
      textDecoration: 'underline',
      color: `${brandColors.black}`,

      '& svg > path': {
        fill: `${brandColors.black}`,
      },
    },

    '& svg': {
      marginRight: typography.pxToRem(10),
    },
  },
  locationDark: {
    color: brandColors.white,
    '&:hover': {
      color: `${brandColors.white}`,
      '& svg > path': {
        fill: `${brandColors.white}`,
      },
    },
  },
  drawerLocationContainer: {
    [breakpoints.up('sm')]: {
      width: typography.pxToRem(400),
    },
  },
  locationHeader: {
    borderBottom: `4px solid ${brandColors.primaryMain}`,
    textAlign: 'center',
    position: 'relative',
    zIndex: zLevels.fixed,
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(24)}`,
    '& h3': { ...type['18_medium'] },
  },
  locationHeaderDark: {
    color: brandColors.white,
  },
  locationCloseContainer: {
    position: 'absolute',
    top: typography.pxToRem(20),
    left: typography.pxToRem(24),
    zIndex: zLevels.fixed,
  },
}));

export default useStyles;
